import { Injectable } from '@angular/core';
import { CatalogNode } from '@catalog/const/v2';
import { CatalogData, CatalogFacade, CatalogRootNodeIdFacade } from '@catalog/data-access/v2';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CatalogService {
  constructor(
    private catalogRootNodeIdFacade: CatalogRootNodeIdFacade,
    private catalogFacade: CatalogFacade,
  ) {}

  getLoadingStatus(): Observable<boolean> {
    return combineLatest({
      isLoadingNode: this.catalogFacade.getLoading(),
      isLoadingRootNodeId: this.catalogRootNodeIdFacade.getRootNodeIdLoading(),
    }).pipe(map(({ isLoadingNode, isLoadingRootNodeId }) => isLoadingNode || isLoadingRootNodeId));
  }

  getRootNode(): Observable<CatalogNode | undefined> {
    return this.catalogRootNodeIdFacade.getRootNode();
  }

  getRootNodeId(): Observable<string> {
    return this.catalogRootNodeIdFacade.getRootNodeId();
  }

  getNode(nodeId: string): Observable<CatalogNode | undefined> {
    return this.catalogFacade.getNode(nodeId);
  }

  getNodes(): Observable<CatalogData> {
    return this.catalogFacade.getNodes();
  }

  loadRootNodeId(): void {
    this.catalogRootNodeIdFacade.loadRootNodeId();
  }

  loadNode(nodeId: string, level = 1): void {
    this.catalogFacade.loadNode({ nodeId, level });
  }
}
